type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
  viewBox?: string;
};
const ToggleSidebarIcon = (props: Props) => (
  <svg
    width={props.width || '18'}
    height={props.height || '18'}
    viewBox={props.viewBox || '0 0 18 18'}
    fill="none"
  >
    <rect
      x="1"
      y="1"
      width="16"
      height="16"
      rx="2"
      stroke={props.strokeColor || 'currentColor'}
      strokeWidth="1.5"
    />
    <line
      x1="7"
      y1="1"
      x2="7"
      y2="17"
      stroke={props.strokeColor || 'currentColor'}
      strokeWidth="1.5"
    />
  </svg>
);

export default ToggleSidebarIcon;
